var _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-35"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-35",
    cx: 250.29,
    cy: 349.52,
    rx: 238.36,
    ry: 122.98,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-35",
    d: "M65,387.25,27.46,365.64c-1.32-.77-1.32-2,0-2.78L269,223.46a5.3,5.3,0,0,1,4.81,0l37.54,21.61c1.33.76,1.33,2,0,2.77L69.81,387.25A5.3,5.3,0,0,1,65,387.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-35",
    cx: 382.96,
    cy: 387.83,
    rx: 61.62,
    ry: 35.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-35",
    d: "M125.6,415.44l-12.69-7.32c-4-2.31-4-6.05,0-8.36L284.51,301A16,16,0,0,1,299,301l12.68,7.32c4,2.31,4,6.06,0,8.36L140.08,415.44A16,16,0,0,1,125.6,415.44Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.93,333s1.45-16.34-3.94-30.36-14.71-24-24.7-26.9-20.11,4.79-10.56,13.46,27.53,19.21,31.5,45.1Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,333s1.45-16.34-3.94-30.36-14.71-24-24.7-26.9-20.11,4.79-10.56,13.46,27.53,19.21,31.5,45.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,328.22h.11a.56.56,0,0,0,.44-.65C53,298.89,34.89,283.64,26,279.58a.57.57,0,0,0-.74.28.55.55,0,0,0,.28.73c8.67,4,26.46,19,31.7,47.17A.55.55,0,0,0,57.8,328.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.79,359.57c0-.82,0-1.63,0-2.45a26.88,26.88,0,0,1,.94-6.8c.63-2.17,2.1-3.9,2.62-6.06a9.34,9.34,0,0,0-1.69-6.94c-1.35-1.9-3.33-3.43-4.06-5.65-.92-2.79.82-5.6.07-8.17s-3.6-4.16-5.93-4.79c-3.11-.85-6.43-.63-9.57-1.37-4.07-.95-7.58-3.42-11.26-5.38s-8-3.47-12-2.28a9.66,9.66,0,0,0-6.19,13c.89,2.17,2.54,3.93,3.74,5.94s1.86,4.32.95,6.51c-.68,1.63-1.89,2.87-2.45,4.56-1.43,4.34-.63,8.24,3.7,10.46,3.2,1.64,6.88,1.17,10.08,2.62,2.32,1.05,4.28,3.21,4.1,5.86-.09,1.38-.48,2.71-.61,4.08-.86,9,5.06,14.68,12.71,15.79a23.57,23.57,0,0,0,11.77-1.72c3.86-1.88,3.08-4.89,3.2-8.69C61,365.24,60.84,362.41,60.79,359.57Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.73,340.49a.56.56,0,0,0,.31,0,27.61,27.61,0,0,1,23.53,1.7.52.52,0,0,0,.7-.22.53.53,0,0,0-.21-.71,28.75,28.75,0,0,0-24.47-1.72.53.53,0,0,0-.25.7A.55.55,0,0,0,27.73,340.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.52,368.14a.5.5,0,0,1-.5-.47c-.89-21.87-22.85-45-37.57-51.31a.48.48,0,0,1-.26-.64.49.49,0,0,1,.64-.26c15,6.42,37.26,29.93,38.17,52.17a.49.49,0,0,1-.47.51Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72.69 364.82 291.72 238.37 291.72 52.66 72.69 179.12 72.69 364.82",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.76 173.97 72.69 179.12 291.72 52.66 300.65 37.2 63.76 173.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.65 243.52 300.65 37.16 291.72 52.66 291.72 238.37 300.65 243.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.76 173.97 72.69 179.12 72.69 364.82 63.76 380.29 63.76 173.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.69 364.82 291.72 238.37 300.65 243.52 63.76 380.29 72.69 364.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.76 173.97 72.69 179.12 291.72 52.66 300.65 37.2 63.76 173.97",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72.69 364.82 291.72 238.37 300.65 243.52 63.76 380.29 72.69 364.82",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "300.65 37.2 294.69 33.76 57.8 170.53 63.76 173.97 300.65 37.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 170.53 63.76 173.97 63.76 380.29 57.8 376.86 57.8 170.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "291.72 52.66 288.74 54.38 288.74 236.65 72.69 361.39 72.69 364.82 291.72 238.37 291.72 52.66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--List--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.67,127V281.73c0,2.07,1.45,2.91,3.24,1.87l90.7-52.38a7.18,7.18,0,0,0,3.24-5.61V70.84Zm12.13,5.82c-1.37.79-2.48.15-2.48-1.43a5.47,5.47,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.49,5.49,0,0,1,191.8,132.78Zm12-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.47,5.47,0,0,1,203.85,125.82Zm12.05-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.47,5.47,0,0,1,215.9,118.86Zm12.06-7c-1.37.8-2.48.15-2.48-1.43a5.51,5.51,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.44A5.47,5.47,0,0,1,228,111.9Zm12-7c-1.37.79-2.48.15-2.48-1.44A5.47,5.47,0,0,1,240,99.22c1.37-.8,2.48-.16,2.48,1.43A5.49,5.49,0,0,1,240,105Zm12.05-7c-1.37.79-2.48.15-2.48-1.43a5.47,5.47,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.49,5.49,0,0,1,252.06,98Zm12.05-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.49,5.49,0,0,1,264.11,91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33,129.05V283.82c0,2.06,1.45,2.9,3.24,1.87l90.7-52.39a7.15,7.15,0,0,0,3.24-5.61V72.92Zm12.13,5.81c-1.37.79-2.48.15-2.48-1.43a5.51,5.51,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.44A5.47,5.47,0,0,1,195.46,134.86Zm12-7c-1.37.79-2.48.15-2.48-1.44a5.47,5.47,0,0,1,2.48-4.29c1.37-.8,2.48-.16,2.48,1.43A5.51,5.51,0,0,1,207.51,127.91Zm12.05-7c-1.37.79-2.48.15-2.48-1.43a5.47,5.47,0,0,1,2.48-4.3c1.37-.8,2.48-.15,2.48,1.43A5.49,5.49,0,0,1,219.56,121Zm12.06-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.49,5.49,0,0,1,231.62,114Zm12-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.47,5.47,0,0,1,243.67,107Zm12.05-7c-1.37.79-2.48.15-2.48-1.43a5.49,5.49,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.43A5.47,5.47,0,0,1,255.72,100.07Zm12-7c-1.37.8-2.48.15-2.48-1.43a5.51,5.51,0,0,1,2.48-4.3c1.37-.79,2.48-.15,2.48,1.44A5.47,5.47,0,0,1,267.77,93.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.23,157.78a2.13,2.13,0,0,1-1-.26,2.64,2.64,0,0,1-1.13-2.42v-6.55a7.57,7.57,0,0,1,3.42-5.93l74.68-43.14a2.34,2.34,0,0,1,3.8,2.19v6.55a7.57,7.57,0,0,1-3.42,5.93l-74.68,43.14A3.31,3.31,0,0,1,194.23,157.78Zm77.58-58a2.57,2.57,0,0,0-1.26.39l-74.68,43.14a6.73,6.73,0,0,0-3.05,5.29v6.55a1.61,1.61,0,0,0,2.67,1.54l74.68-43.14a6.73,6.73,0,0,0,3.05-5.28v-6.55a1.92,1.92,0,0,0-.76-1.77A1.29,1.29,0,0,0,271.81,99.73Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.17,
    y: 128.06,
    width: 93.53,
    height: 0.75,
    transform: "translate(-33.01 133.74) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,270a2,2,0,0,1-1-.27,2.62,2.62,0,0,1-1.13-2.42V169.59a7.6,7.6,0,0,1,3.42-5.94l74.68-43.13a2.34,2.34,0,0,1,3.8,2.19v97.72a7.57,7.57,0,0,1-3.42,5.93L195.87,269.5A3.41,3.41,0,0,1,194.23,270Zm77.58-149.22a2.57,2.57,0,0,0-1.26.39L195.87,164.3a6.73,6.73,0,0,0-3.05,5.29V267.3a2,2,0,0,0,.76,1.78,1.93,1.93,0,0,0,1.91-.23l74.68-43.14a6.73,6.73,0,0,0,3.05-5.28V122.71a1.92,1.92,0,0,0-.76-1.77A1.29,1.29,0,0,0,271.81,120.77Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 149.05,
    width: 93.72,
    height: 0.75,
    transform: "translate(-43.5 136.6) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 156.06,
    width: 93.72,
    height: 0.75,
    transform: "translate(-47 137.54) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 163.07,
    width: 93.72,
    height: 0.75,
    transform: "translate(-50.51 138.48) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 170.09,
    width: 93.72,
    height: 0.75,
    transform: "translate(-54.02 139.42) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 177.1,
    width: 93.72,
    height: 0.75,
    transform: "translate(-57.53 140.36) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 184.11,
    width: 93.72,
    height: 0.75,
    transform: "translate(-61.03 141.3) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 191.12,
    width: 93.72,
    height: 0.75,
    transform: "translate(-64.54 142.24) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 198.14,
    width: 93.72,
    height: 0.75,
    transform: "translate(-68.05 143.18) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 205.15,
    width: 93.72,
    height: 0.75,
    transform: "translate(-71.56 144.12) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 212.16,
    width: 93.72,
    height: 0.75,
    transform: "translate(-75.07 145.06) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 219.18,
    width: 93.72,
    height: 0.75,
    transform: "translate(-78.57 146) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 226.19,
    width: 93.72,
    height: 0.75,
    transform: "translate(-82.08 146.94) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 233.2,
    width: 93.72,
    height: 0.75,
    transform: "translate(-85.59 147.88) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 240.21,
    width: 93.72,
    height: 0.75,
    transform: "translate(-89.1 148.82) rotate(-30.01)",
    style: {
      fill: "#692ED6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,142l0,.16a1.76,1.76,0,0,1-.86,1.4c-1.11.64-2.21,1.29-3.32,2v.08c0,2.63-.12,5.29-.12,7.92,0,.89,0,1.74,0,2.59s.09,1.41.09,2.13a1.65,1.65,0,0,1-.74,1.6c-.44.25-.8.09-.8-.69V158c0-2.43,0-4.85,0-7.25,0-1.38,0-2.67,0-4.09v-.15c-.83.57-1.68,1.14-2.51,1.72-.18.13-.58.42-.79.54-.5.29-.87,0-.87-.65a2.09,2.09,0,0,1,.91-1.59l2.83-1.64c1.2-.69,2.42-1.54,3.62-2.29l1-.65c.22-.15.43-.31.65-.44C204.24,141.23,204.61,141.34,204.61,142Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,146.59a4.88,4.88,0,0,1,.09,1.13,12.08,12.08,0,0,1-.21,2.26,9.37,9.37,0,0,1-3.85,5.64l-.18.1a2.2,2.2,0,0,1-2.62-.09,4.32,4.32,0,0,1-1.09-3.34,10.76,10.76,0,0,1,2.71-6.92,5.58,5.58,0,0,1,1.36-1.11,3.07,3.07,0,0,1,1.74-.48,2.71,2.71,0,0,1,2,2.79Zm-1.42,2.34c0-.52-.11-.83-.12-1.37-.32-1.83-1.45-1.86-2.27-1.38a6.61,6.61,0,0,0-2.65,5.35c0,1.84.85,3.12,2.35,2.26a5.72,5.72,0,0,0,2-2.12A5.49,5.49,0,0,0,210.12,148.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.15,136.3v.19A13.78,13.78,0,0,1,218.87,149a3.44,3.44,0,0,1-.75.37,1.76,1.76,0,0,1-.57.52l-.06,0c-.3.15-.71.29-.71-.47,0-1.5.08-3.07.08-4.59,0-3.2-.16-6.44-.22-9.49V135a2,2,0,0,1,.46-1.48,1.25,1.25,0,0,1,.22-.16c.35-.21.6-.18.75,0a4.84,4.84,0,0,1,.5-.4,14.33,14.33,0,0,1,1.54-1c1.59-.92,3.2-1.36,4.37-.51S226.15,134,226.15,136.3Zm-1.51,1.06c0-1.58-.26-3.14-1.1-3.85s-2.15-.25-3.31.42a11,11,0,0,0-1.32.93c-.22.16-.45.38-.67.52v2.38l.1,4.9c0,1.59.06,3,.07,4.38.23-.14.45-.2.7-.34a10.87,10.87,0,0,0,4.54-4.66A11.79,11.79,0,0,0,224.64,137.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.24,132.9a5,5,0,0,1,.09,1.14,12.08,12.08,0,0,1-.21,2.26,9.33,9.33,0,0,1-3.85,5.64l-.17.09a2.18,2.18,0,0,1-2.63-.09,4.28,4.28,0,0,1-1.09-3.33,10.81,10.81,0,0,1,2.71-6.93,6.09,6.09,0,0,1,1.36-1.11,3.05,3.05,0,0,1,1.74-.47,2.71,2.71,0,0,1,2.05,2.78Zm-1.42,2.34c0-.51-.1-.82-.12-1.37-.32-1.82-1.45-1.85-2.27-1.38a6.64,6.64,0,0,0-2.65,5.35c0,1.85.85,3.13,2.35,2.27a5.68,5.68,0,0,0,2-2.13A5.47,5.47,0,0,0,233.82,135.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,129.88a2.07,2.07,0,0,1-1.18,1.63c-1.48.93-2.93,1.81-4.41,2.87-.59.42-1.22.93-1.79,1.26a.83.83,0,0,1-.2.09,1.94,1.94,0,0,1-.29.21c-.34.2-.87.25-.87-.63,0-2,0-4.09,0-6.13,0-2.2,0-4.45-.09-6.21,0-.38-.08-.76-.08-1.17a2.47,2.47,0,0,1,.18-1,1.4,1.4,0,0,1,.53-.57c.78-.45.81.37.85,1.15,0,3.6,0,8.09.1,12.15l0,0c1.9-1.3,3.49-2.34,5.79-3.87a6.15,6.15,0,0,1,.52-.37C248.8,129,249.2,129.22,249.2,129.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,119.79c0,.1,0,.22,0,.33l-.05,4.22c0,.5,0,1,0,1.51v1.64c0,.24,0,.44,0,.67v.27a.65.65,0,0,1,0,.21,1.41,1.41,0,0,1-.65,1.22l-.09,0c-.59.34-.82-.1-.82-.66,0-.24,0-.51,0-.74l0-1c0-.72,0-1.45,0-2.17v-.57c0-1.19,0-2.36-.06-3.54V121a2.35,2.35,0,0,1,.23-1.18,1.69,1.69,0,0,1,.65-.74C252.11,118.81,252.37,119.11,252.37,119.79Zm.11-5.08a1,1,0,0,1,.06.41,1.86,1.86,0,0,1-.49,1.25,1.32,1.32,0,0,1-.35.29c-.36.21-.73.18-.79-.34a2.44,2.44,0,0,1,0-.28,1.92,1.92,0,0,1,.43-1.28,1.42,1.42,0,0,1,.4-.33A.45.45,0,0,1,252.48,114.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06,115.34a2.07,2.07,0,0,1-.86,1.49,1,1,0,0,1-.41.12,3.68,3.68,0,0,0-1,.42c-1,.6-2.08,1.63-2.08,2.42s1.35-.13,2.3-.65c1.17-.64,3.46-1.74,3.46,1.28,0,2.69-2.14,5.22-4.11,6.36a3.48,3.48,0,0,1-2,.58,1.09,1.09,0,0,1-1.09-1,1.81,1.81,0,0,1,.78-1.27c.5-.29.78,0,.95,0a2,2,0,0,0,1.47-.38c.78-.45,2.61-1.84,2.61-3.54,0-1.32-1.14-.74-2.1-.19-1.88,1.09-3.68,1.94-3.68-.5A4.83,4.83,0,0,1,255,118a8,8,0,0,1,2.84-2.71C258.82,114.79,260.06,114.17,260.06,115.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,111.1a1.65,1.65,0,0,1-.82,1.38,1.33,1.33,0,0,1-.26.11l-1.15.67-.05,0,0,2.37c0,.72,0,2.81.1,4.34l0,1c0,.9-.25,1.27-.64,1.5-.68.39-.92-.13-.92-.6,0-1.71,0-2.59,0-3.88s0-2.77,0-3.83l-.51.38c-.62.46-.77.57-.85.61-.38.23-.52-.19-.52-.7,0-1.15.54-1.42,1.8-2.17,0-.76-.11-1.38-.11-2.18a1.79,1.79,0,0,1,.34-1,1.38,1.38,0,0,1,.4-.33c.74-.43.85.43.85,1.42,0,.41,0,.81,0,1.18.52-.36,1-.67,1.29-.85C267.25,110.17,267.66,110.32,267.66,111.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,173.65c-.77,1-1.52,2.31-2.7,2.92-.3.15-.67.28-.94,0a3.23,3.23,0,0,1-.51-1.95c0-.32-.54-.57-.75-.27-1,1.46-1.65,3.13-2.79,4.5-.46.56-1.17,1.33-2,1.27a1.16,1.16,0,0,1-1-1l.38-.51a10.16,10.16,0,0,0,2-3.65,2.47,2.47,0,0,0-.23-1.81.78.78,0,0,0-1.14-.13,5.73,5.73,0,0,0-1.6,3.27,6.9,6.9,0,0,0-.18,2.49c-.17.24-.34.48-.52.71a15.57,15.57,0,0,1-2,2.17c-.21.17-.57.53-.87.53h0s0,0,0,0-.11-.33-.13-.45c0-.29-.57-.56-.78-.28a9.62,9.62,0,0,0-.93,1.69,1.77,1.77,0,0,0-.38-.86c-.59-.64-1.58-.32-2.16.16a4.74,4.74,0,0,0-.77.89,6.92,6.92,0,0,0-.07-2.87,1.57,1.57,0,0,0-2.08-1.11c-1,.43-1.59,1.72-2,2.69a12,12,0,0,0-.61,2,3.79,3.79,0,0,0-.15,1.27l-.32.09c-.14,0-.12.3,0,.32a1.62,1.62,0,0,0,.69.06.2.2,0,0,0,.19-.23,9,9,0,0,1,.68-2.59,6,6,0,0,1,1.64-2.73c.78-.58,1.13.1,1.21.84a13.15,13.15,0,0,1-.3,3.48,17.35,17.35,0,0,0-.39,2.88.85.85,0,0,0,0,.16h0v.09c0,.4.89.55.87.09a7,7,0,0,1,1.53-4.14c.19-.25,1-1.2,1.38-.87.18.15.16.7.18.91,0,.41,0,.82.06,1.23a.48.48,0,0,0,.84.19c.46-.79.75-1.66,1.19-2.45a1,1,0,0,0,1.2.24,5.88,5.88,0,0,0,2.13-1.84c.34-.39.66-.8,1-1.22a.36.36,0,0,0,0,.09,2,2,0,0,0,2.51.79,6.55,6.55,0,0,0,2.61-2.73c.45-.72.84-1.49,1.27-2.23.26,1,.85,2,2.08,1.69a5.66,5.66,0,0,0,3.16-3.39C222.55,173.75,222.16,173.4,222,173.65Zm-9.43.23a2.4,2.4,0,0,0,.21-.23l0,0a3.47,3.47,0,0,1,.07.92,8,8,0,0,1-1.63,3.21,8.77,8.77,0,0,1,.64-2.73A4.59,4.59,0,0,1,212.54,173.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,155.05c-.49.32-1,.6-1.52.87a2.3,2.3,0,0,1-1.81.23,2.53,2.53,0,0,0-2.35.35c-1.07.85-1.34,2.37-2.32,3.27-.37-.65-.32-1.5-.85-2.09a.41.41,0,0,0-.61,0,17.86,17.86,0,0,1-2.85,3.39c-.39.32-1,.7-1.5.51l.3-.45c.7-1,1.61-2.21,1.56-3.51,0-.81-.43-2-1.48-1.69a2.78,2.78,0,0,0-1.55,2.18,5.1,5.1,0,0,0,.21,3.52c-.18.27-.36.55-.55.82a8.2,8.2,0,0,1-1.88,2.1,1.67,1.67,0,0,1-1.11.39c-.52-.06-.86-.54-1.11-1-.12-.18-.44-.39-.62-.16a8.6,8.6,0,0,0-1.33,2.9,2.8,2.8,0,0,0-.61-.77.34.34,0,0,0-.48,0,7,7,0,0,0-1.8,3c-.16-1.17-.5-2.31-1.62-2.56a2.81,2.81,0,0,0-2.65,1.17c-.82,1-1.1,2.52-2.14,3.37-.09.08,0,.35.12.28,1.88-.92,1.81-3.9,4.17-4.24,1.83-.27,1.48,3,1.7,4.13.06.31.63.53.68.11a8.15,8.15,0,0,1,1.89-4.55,5.66,5.66,0,0,1,.53,1.11c.09.21.56.4.65.08a11.79,11.79,0,0,1,1.26-3.2,2,2,0,0,0,2,.9,4.32,4.32,0,0,0,2.31-1.73,18.16,18.16,0,0,0,1.19-1.68,1.67,1.67,0,0,0,1,.17,4.37,4.37,0,0,0,2.57-1.75,20.59,20.59,0,0,0,1.5-2c.07.24.11.5.18.72a2.48,2.48,0,0,0,.66,1.17.43.43,0,0,0,.54.1c1.24-.84,1.44-2.53,2.56-3.47a1.75,1.75,0,0,1,1.1-.46c.51,0,1,.26,1.52.28a4.12,4.12,0,0,0,2.78-1.47C255,155.35,254.83,154.94,254.65,155.05Zm-14.48,4.47a5.42,5.42,0,0,1,.59-2.26c.15-.27.46-.68.8-.72s.23,0,.31.19a2.46,2.46,0,0,1,.12.85,5.7,5.7,0,0,1-1.29,2.81l-.4.6A3.55,3.55,0,0,1,240.17,159.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.58,188.91c-1.1.89-1.67,2.17-2.6,3.19a6,6,0,0,1-.6-.89.4.4,0,0,0-.64-.13c-.19.21-.38.39-.54.6A2,2,0,0,1,227,191a.44.44,0,0,0-.73-.28c-1.53,1.77-2.41,4.78-4.62,5.68a4.76,4.76,0,0,0-.38-3.9c-.11-.18-.42-.38-.6-.16-1.35,1.6-1.69,3.93-3.36,5.26a1.73,1.73,0,0,1-.24-1c0-.33-.57-.62-.73-.23s-.32,1.06-.48,1.59a4.57,4.57,0,0,1-.7,1.67c-.58.67-.8-.62-.82-1,0-.76.09-1.51.05-2.26,0-.33-.58-.62-.73-.23a46,46,0,0,1-2.62,5.43c-.13.25-.74,1.63-1.15,1.58s-.79-1.21-.92-1.45-.45-.33-.62-.17a5.33,5.33,0,0,0-1.14,1.78,3.46,3.46,0,0,0-.28-.82.49.49,0,0,0-.71-.22,40.94,40.94,0,0,0-4.37,5,13.25,13.25,0,0,1-2.46,2.39c-.19.13-.73.53-1,.43s-.19-.34-.21-.52a8.34,8.34,0,0,1,1.1-3.93,17.75,17.75,0,0,1,1.07-2,4.52,4.52,0,0,1,1.42-1.59c.27-.15.64-.27.78.11a2.46,2.46,0,0,1-.12,1.23c-.17.65-.43,1.29-.64,1.93l-.48-.06c-.18,0-.15.29,0,.34a4.23,4.23,0,0,1,.58.17c.08,0,.15,0,.2,0,.58-.94,2-3.58.55-4.38s-2.87,1.59-3.43,2.58a12.9,12.9,0,0,0-1.82,4.93c-.06.65,0,1.49.64,1.84.84.46,1.83-.3,2.45-.81,2.31-1.89,3.76-4.58,5.91-6.62a9.56,9.56,0,0,1,0,2.45h0v.09c0,.38.69.58.8.17a10.1,10.1,0,0,1,1.37-3.49,2.72,2.72,0,0,0,1,1.24c.6.31,1.08-.09,1.43-.57a22.76,22.76,0,0,0,1.77-3.21c.28-.55.55-1.09.8-1.65a4.91,4.91,0,0,0,.07.86c.14.69.73,1.55,1.54,1.37s1-1,1.19-1.57c.13-.38.23-.77.33-1.16a1.46,1.46,0,0,0,.55.52.32.32,0,0,0,.34,0c1.76-1.23,2.17-3.38,3.31-5.07.43,1.23.54,3.29-.89,3.4-.46,0-.24.66.12.69a.33.33,0,0,1,.1,0h0c3.39.13,4.49-3.16,6.16-5.53a2.48,2.48,0,0,0,.53.73c.16.15.52.27.62,0a1.6,1.6,0,0,1,.39-.59,8,8,0,0,0,.72.93c.1.11.38.24.52.1,1.08-1.05,1.63-2.5,2.67-3.58C232.12,189.18,231.78,188.74,231.58,188.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,175.4a5.85,5.85,0,0,0-1.44,2.2,4.82,4.82,0,0,1-1.72,2.2c-.87.46-1.37-.15-1.38-.94.49-.82,1-1.66,1.51-2.43.21-.3-.25-.65-.53-.56a3.07,3.07,0,0,0-1.74,2.66,10.73,10.73,0,0,1-2.12,2.79c-.22.2-.61.54-.95.47s-.45-.68-.5-1c-.16-1.19-1.17-1-2-.43-1.18.84-1.45,2.41-2.2,3.6-.25-.4-.4-.86-.66-1.25a.48.48,0,0,0-.56-.19c-1.51.79-1.52,2.45-2,3.86,0-.48,0-1,0-1.41a3.11,3.11,0,0,0-.88-2.41c-1.61-1.17-3.12,1.67-3.64,2.79-.25.54-.78,1.55-.24,2.08.23.21.37-.17.22-.35s.28-.82.34-1a12.33,12.33,0,0,1,.79-1.36,9.12,9.12,0,0,1,.94-1.21,1.81,1.81,0,0,1,.85-.62c.88-.11.87,1.54.88,2.06a10.47,10.47,0,0,0,.14,2.74.44.44,0,0,0,.72.18c1-1.26.75-3.48,2-4.5a4.17,4.17,0,0,0,.9,1.38.42.42,0,0,0,.62,0c.9-1.11,1.08-2.74,2.16-3.71a2.5,2.5,0,0,1,.41-.29c.08,0,.24-.09.35-.15s0,.15,0,.16a2.12,2.12,0,0,0,.48,1.24c1.47,1.55,3.21-.94,4.06-2.25a1.56,1.56,0,0,0,1.46.92c1.21.05,2-1,2.58-1.94a16.61,16.61,0,0,1,1.61-2.82C255.76,175.66,255.23,175.21,255,175.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.83,221.58a2.86,2.86,0,0,0-2.5-.27,10.65,10.65,0,0,0-2.42,1.06c-.58.32-1.84.92-1.73,1.71,0,.1.15.3.27.19a11.76,11.76,0,0,1,3.42-2,3.72,3.72,0,0,1,2-.37c.78.17.94,1.07.9,1.74a5.68,5.68,0,0,1-1.64,3.21,12.11,12.11,0,0,1-3.22,2.61c0-.18.05-.36.08-.54.1-.58.19-1.15.29-1.73s.19-1.14.29-1.7a9.58,9.58,0,0,0,.22-1.92c0-.16-.26-.43-.38-.2A6.78,6.78,0,0,0,202,225c-.14.6-.27,1.21-.38,1.82s-.22,1.17-.33,1.75l-.15.87c0,.15-.06.29-.08.44h0a3.7,3.7,0,0,1-3.81-.26c-.29-.22-.27.17-.18.34a2.56,2.56,0,0,0,2,1.1,5.21,5.21,0,0,0,2.17-.34,11.25,11.25,0,0,0,4.29-2.88,7.09,7.09,0,0,0,2.21-3.9A2.71,2.71,0,0,0,206.83,221.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,210.76c-.28,1-2.31,4.66-3.63,3a2,2,0,0,1-.37-.77,16,16,0,0,0,1.6-3.44c.19-.63.4-1.56-.25-2s-1.45,0-1.76.69a7.36,7.36,0,0,0-.52,3,6.8,6.8,0,0,0,.12,1.57c-.13.22-.25.44-.39.65a20.47,20.47,0,0,1-1.23,1.85c-.17.22-.63.9-1,.87s-.42-1.1-.51-1.37-.41-.5-.62-.26c-.87,1-.85,2.53-1.6,3.61-.36.52-1,.66-1.25,0a8.55,8.55,0,0,1-.33-2c-.05-.24-.58-.53-.67-.18-.18.66-.36,1.33-.56,2a8.52,8.52,0,0,1-.86,2.23c-.12.19-.29.42-.56.38s-.41-.41-.49-.64a4.9,4.9,0,0,1-.23-2.05c0-.38-.62-.74-.76-.28a17.59,17.59,0,0,1-1.08,2.71c-.4.82-1,2.12-1.91,2.49a.76.76,0,0,1-.28.05c.14-.33.26-.66.37-1,.39-1.19.84-3.11-.3-4.06a.44.44,0,0,0-.55-.08,3.62,3.62,0,0,0-1.09,2.38c0,.19,0,.39-.05.6-.72-.89-1.75.25-2.19,1-.58,1-1.28,2.71-.77,3.87s1.87.83,2.63.17a7.37,7.37,0,0,0,1.65-2.27,1.5,1.5,0,0,0,1.25-.14,5.62,5.62,0,0,0,1.86-2.41c.22-.43.41-.87.6-1.32a4.68,4.68,0,0,0,.17.53,1.47,1.47,0,0,0,1.87,1c.69-.3,1-1.39,1.19-2,.15-.43.27-.87.38-1.3a2.85,2.85,0,0,0,.25.63,1.33,1.33,0,0,0,1.71.64c.66-.32,1-1.21,1.2-1.84s.34-1.13.59-1.66c.23.75.61,1.5,1.47,1.09s1.51-1.59,2-2.41c.13-.19.25-.39.37-.59,0,0,0,0,0,.06,1.71,2.9,4.75-.67,5.11-2.67C232.51,210.75,231.88,210.35,231.76,210.76Zm-19.28,7.83a3.7,3.7,0,0,1,0,2.28,10.09,10.09,0,0,1-.46,1.41,3.63,3.63,0,0,1-.19-1.27A4.25,4.25,0,0,1,212.48,218.59Zm-3.57,7c-.65-.37-.06-2,.13-2.51s1.19-3,2-1.92l0,0a2.94,2.94,0,0,0,.51,1.67l.12.14a9.42,9.42,0,0,1-.72,1.23C210.61,224.71,209.64,226,208.91,225.63Zm18.9-16.26c.05-.22.46-1.69.94-1.35.23.17-.09,1.11-.17,1.33a14.51,14.51,0,0,1-1,2.26A9.34,9.34,0,0,1,227.81,209.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.07,196.44c-1,.52-3.35.06-3-1.41.05-.2-.31-.63-.45-.35-.46.92-.9,1.86-1.42,2.75a9.48,9.48,0,0,1-1.27,1.87,4.59,4.59,0,0,1-1.25,1c-.11.06-.38.21-.5.16s0-.56,0-.72-.32-.59-.53-.38c-1.1,1.14-1.6,2.75-2.81,3.79a1,1,0,0,1-.43-.82c0-.27-.44-.61-.66-.33-1,1.32-1.08,3.23-2.24,4.47-.82.88-.95-.51-.93-1.11s.11-1.13.18-1.69l0-.22c0-.23,0-.45,0-.67s-.56-.54-.57-.13a8.8,8.8,0,0,1-.1,1,7.64,7.64,0,0,1-.71,2,5.51,5.51,0,0,1-2,2.36c-.18.1,0,.5.14.42A5.39,5.39,0,0,0,241,206c.09.77.6,1.7,1.51,1.41s1.31-1.44,1.64-2.18.51-1.45.86-2.12a2,2,0,0,0,.86.79.37.37,0,0,0,.34,0,12.51,12.51,0,0,0,2.46-3.34.72.72,0,0,0,.52.51c.53.15,1.13-.29,1.52-.6a6,6,0,0,0,1.41-1.57,17.16,17.16,0,0,0,1.67-3,2.53,2.53,0,0,0,3.57,1.1C257.55,196.76,257.3,196.31,257.07,196.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.66,229.12c0-.27-.47-.51-.62-.22a13.91,13.91,0,0,0-.88,2.41,5.86,5.86,0,0,1-1.22,2.59c-.77.71-1-.44-1-1.05a6.37,6.37,0,0,0,.51-2.59c0-.29-.49-.63-.67-.27a6.2,6.2,0,0,0-.54,2.67,16,16,0,0,1-1,2c-1-.68-1.67.62-2.26,1.46a3.59,3.59,0,0,1-.09-1.49c0-.27-.43-.62-.64-.34a6.85,6.85,0,0,0-.77,1.75c-.18.48-.46,1.56-1,1.76-1,.35-.62-3.41-.65-3.94,0-.25-.44-.64-.65-.33-1.26,1.91-1.32,4.38-2.72,6.22-.09.13-.27.25-.34.38l0,0a.22.22,0,0,1,0,.1.36.36,0,0,0,0-.1c-.11.18-.05-.1,0,0a5.62,5.62,0,0,1-.16-.71,16.83,16.83,0,0,1,0-2.13c0-.3-.53-.6-.71-.3a41.45,41.45,0,0,0-1.78,4.17c-.56,1.26-1.49,3.06-3.08,3.12-.61,0-.77-.45-.73-1a8,8,0,0,0,1.13-.88,6.23,6.23,0,0,0,2-3.18c.12-.61,0-1.59-.81-1.61s-1.51,1.3-1.84,2a12.77,12.77,0,0,0-.9,2.27,7,7,0,0,0-.25,1.16,4.62,4.62,0,0,1-2,.68c-.22,0-.13.43.07.43a4.82,4.82,0,0,0,2-.46,1.93,1.93,0,0,0,.15.52,1.59,1.59,0,0,0,1.88.75,3.54,3.54,0,0,0,2.09-1.46,20.24,20.24,0,0,0,2.11-4.52c.06,1.11.34,2.23,1.26,1.9a2.18,2.18,0,0,0,.91-.94,9.06,9.06,0,0,0,.87-1.8c.34-.91.59-1.87.95-2.78a7.51,7.51,0,0,0,0,1.06c.07.77.26,1.9,1.18,2.07s1.24-.72,1.51-1.31c.18-.39.3-.83.45-1.26a1.69,1.69,0,0,0,.65,1,.3.3,0,0,0,.37,0c.28-.35.49-.74.75-1.11s.65-.89,1.12-.39a.31.31,0,0,0,.5,0c.27-.45.54-.94.8-1.44a1.25,1.25,0,0,0,1.43.88c1-.19,1.49-1.58,1.79-2.43.16-.44.28-.89.41-1.34a19,19,0,0,1-.56,4.76l-.09,0c-1.34.69-3.1.82-3.63,2.47-.47,1.44.93,2.24,2.15,1.62a4.43,4.43,0,0,0,1.94-2.65,16.19,16.19,0,0,0,.73-4.08A30.26,30.26,0,0,0,233.66,229.12Zm-20.57,12.22a13.36,13.36,0,0,1,.7-1.6,3.54,3.54,0,0,1,1-1.36c.28-.17.26-.1.27.25a5,5,0,0,1-1.61,3.1,6.64,6.64,0,0,1-.72.68C212.85,242,213,241.56,213.09,241.34Zm18.15-2.68c-.29.33-1.31,1.18-1.69.64-.23-.33.06-.92.23-1.2a2.31,2.31,0,0,1,1-.81c.5-.23,1-.39,1.5-.63-.05.13-.08.26-.13.39A5.42,5.42,0,0,1,231.24,238.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.06 237.92 219.06 237.92 219.06 237.93 219.06 237.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,223.4a2.28,2.28,0,0,0-2.47-1.15,4.27,4.27,0,0,0-1.6.64,3,3,0,0,0-.75.72c-.06-.13-.13-.24-.2-.36a3.83,3.83,0,0,0-.84-.91,2,2,0,0,0-2-.48,1.57,1.57,0,0,0-.69,1.92,7.76,7.76,0,0,0,1.31,2.26,19.82,19.82,0,0,1,1.62,2.15.34.34,0,0,0,.49.11,11.51,11.51,0,0,1,2.14-1.2,10.53,10.53,0,0,0,2.47-1.59A1.8,1.8,0,0,0,243,223.4Zm-3.43,3a15.55,15.55,0,0,0-1.88,1,28.67,28.67,0,0,1-2.47-3.46c-.22-.49-.33-1.1.27-1.38s1.22.24,1.59.59a3.1,3.1,0,0,1,.75,1c0,.05,0,.13.06.19a.39.39,0,0,0,.15.35.23.23,0,0,0,.14,0s.22-.1.18-.12.34-.46.38-.51a3,3,0,0,1,.44-.43,3.49,3.49,0,0,1,1.17-.59,1.73,1.73,0,0,1,2.05.55c.27.52-.22,1.05-.64,1.4A11.68,11.68,0,0,1,239.6,226.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,245.26c-.29.21-.49.31-.77.06a3.08,3.08,0,0,1-.71-1.16,5.64,5.64,0,0,1-.55-2.23c0-.41-.76-.61-.77-.12a22.52,22.52,0,0,1-.22,3.48,8,8,0,0,1-.45,1.73c-.12.3-.3.83-.61,1s-.63-.65-.74-.93a5.69,5.69,0,0,1-.44-2.07h0s0-.06,0-.1c0-.39-.86-.56-.85-.11v.1h0a7.74,7.74,0,0,1-.53,2.81,5.92,5.92,0,0,1-.82,1.6c.08-1.31.17-2.82-1.05-3.52-1.89-1.08-3.36,1.48-3.47,3.06,0,.19.35.55.44.25a5.85,5.85,0,0,1,1.08-2.14c.43-.52,1.28-1.11,1.86-.45a2.73,2.73,0,0,1,.38,1.84c0,.62-.11,1.23-.11,1.85a.48.48,0,0,0,.66.44,4.5,4.5,0,0,0,1.82-2.53,7.46,7.46,0,0,0,.26-.8,1.34,1.34,0,0,1,.07.18c.28.6.78,1.37,1.54,1.33,1-.06,1.37-1.45,1.58-2.21a9.61,9.61,0,0,0,.32-2l.21.43c.5.9,1.57,1.77,2.46.8C210.86,245.5,210.28,245.06,210,245.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,136.23c-.33-.29-.93-.6-1.36-.3a9.7,9.7,0,0,0-2.19,2.91c-.74,1.17-3.87,8.35-5.24,11.36-.15.32-.34.76-.68.67a.59.59,0,0,1-.3-.2l-2.83-2.75c-.73.78-1.53,1.78-1.21,2.79a2.75,2.75,0,0,0,.91,1.18,13.31,13.31,0,0,0,1.86,1.4,4.86,4.86,0,0,0,1.81.82,1.78,1.78,0,0,0,1.49-.51c1.21-1.35,6.91-11.21,7.51-12.3a6.2,6.2,0,0,0,1.21-3.12A3.35,3.35,0,0,0,271.3,136.23Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,177.51c-.33-.29-.93-.6-1.36-.29a9.45,9.45,0,0,0-2.19,2.91c-.74,1.16-3.87,8.34-5.24,11.36-.15.32-.34.75-.68.67a.69.69,0,0,1-.3-.21l-2.83-2.74c-.73.77-1.53,1.77-1.21,2.79a2.75,2.75,0,0,0,.91,1.18,13.24,13.24,0,0,0,1.86,1.39,4.88,4.88,0,0,0,1.81.83,1.75,1.75,0,0,0,1.49-.52c1.21-1.34,6.91-11.2,7.51-12.29a6.27,6.27,0,0,0,1.21-3.12A3.35,3.35,0,0,0,271.3,177.51Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.24,182.53a2.08,2.08,0,0,0-1.34-.29.86.86,0,0,0-.67.64c-1.72.63-3.43,1.29-5.17,1.89-2.13.72-4.27,1.4-6.39,2.14-4.23,1.48-8.39,3.12-12.54,4.79-8.33,3.36-16.65,6.74-25.17,9.61-2,.65-3.89,1.26-5.8,2-1.25.5-2.54.83-3.77,1.35a.77.77,0,0,0-.46.36.52.52,0,0,0,.28.62c.78.43,2.33-.24,3.1-.5,1.64-.55,3.24-1.16,4.9-1.68,4.39-1.37,8.73-2.89,13-4.5,8.41-3.14,16.64-6.77,25.09-9.83,2.45-.88,4.93-1.68,7.4-2.51a69.24,69.24,0,0,0,7.3-2.68A.85.85,0,0,0,254.24,182.53Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.41,239.6c-2.5,1.37-12.34,7.38-14.9,8.79-4.37,2.41-8.65,4.9-12.93,7.46-.21.13-.45.28-.51.52-.19.82,1,.24,1.24.13.68-.31,1.36-.64,2-1,1.33-.69,8.36-4.69,10.57-5.89,2.59-1.41,12.66-7.45,15.22-8.87C228.78,240.39,228,239.28,227.41,239.6Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,227.31c-1,.52-10.69,6.5-12.95,7.83a1.6,1.6,0,0,0-.55.45.54.54,0,0,0,0,.66c.23.23.62.09.91-.06,4.33-2.23,8.51-4.72,12.69-7.21a2.36,2.36,0,0,0,.62-.47C249.92,228,249.48,227,248.78,227.31Z",
    style: {
      fill: "#692ED6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "83.44 182.5 169.47 132.83 169.47 206.62 83.44 256.29 83.44 182.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.36 185.91 175.39 136.25 175.39 210.04 89.36 259.71 89.36 185.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.9 184.5 86.9 258.29 89.36 259.71 89.36 185.91 86.9 184.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.39 136.25 172.93 134.83 86.9 184.5 89.36 185.91 175.39 136.25",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.39 136.25 172.93 134.83 86.9 184.5 89.36 185.91 175.39 136.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "86.9 184.5 89.36 185.91 89.36 200.1 86.9 198.69 86.9 184.5",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "86.9 184.5 89.36 185.91 89.36 200.1 86.9 198.69 86.9 184.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "89.36 200.1 175.39 150.44 175.39 136.25 89.36 185.91 89.36 200.1",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "89.36 200.1 175.39 150.44 175.39 136.25 89.36 185.91 89.36 200.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.2,204.68c0,.79.58,1.08,1.31.67l6.45-3.73a2.8,2.8,0,0,0,1.31-2.17c0-.78-.59-1.08-1.31-.66l-6.45,3.72A2.82,2.82,0,0,0,95.2,204.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.08,198.4c0,.79.58,1.08,1.31.66l6.45-3.72a2.82,2.82,0,0,0,1.31-2.17c0-.79-.59-1.08-1.31-.67l-6.45,3.73A2.8,2.8,0,0,0,106.08,198.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,192.12c0,.78.59,1.08,1.31.66l6.45-3.72a2.82,2.82,0,0,0,1.31-2.18c0-.78-.59-1.08-1.31-.66l-6.45,3.72A2.84,2.84,0,0,0,117,192.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,185.84c0,.78.59,1.08,1.31.66l6.45-3.72a2.82,2.82,0,0,0,1.31-2.18c0-.78-.59-1.08-1.31-.66l-6.45,3.72A2.82,2.82,0,0,0,127.84,185.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.72,179.55c0,.79.59,1.08,1.31.67l6.45-3.73a2.78,2.78,0,0,0,1.31-2.17c0-.78-.58-1.08-1.31-.66L140,177.38A2.82,2.82,0,0,0,138.72,179.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,173.27c0,.79.59,1.08,1.31.66l6.45-3.72a2.79,2.79,0,0,0,1.31-2.17c0-.79-.58-1.08-1.31-.67l-6.45,3.73A2.8,2.8,0,0,0,149.6,173.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.48,167c0,.78.59,1.08,1.31.66l6.45-3.72a2.79,2.79,0,0,0,1.31-2.18c0-.78-.58-1.08-1.31-.66l-6.45,3.72A2.84,2.84,0,0,0,160.48,167Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.76 212.14 103.68 207.59 103.68 214.72 95.76 219.39 95.76 212.14",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.76 222.16 103.68 217.6 103.68 224.74 95.76 229.41 95.76 222.16",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.76 232.18 103.68 227.62 103.68 234.75 95.76 239.42 95.76 232.18",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.76 242.19 103.68 237.64 103.68 244.77 95.76 249.44 95.76 242.19",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.65 205.85 114.57 201.3 114.57 208.43 106.65 213.1 106.65 205.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.65 215.87 114.57 211.32 114.57 218.45 106.65 223.12 106.65 215.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.65 225.89 114.57 221.34 114.57 228.47 106.65 233.14 106.65 225.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.65 235.91 114.57 231.35 114.57 238.49 106.65 243.16 106.65 235.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.54 199.57 125.45 195.01 125.45 202.15 117.54 206.81 117.54 199.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.54 209.59 125.45 205.03 125.45 212.16 117.54 216.83 117.54 209.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.54 219.6 125.45 215.05 125.45 222.18 117.54 226.85 117.54 219.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.54 229.62 125.45 225.07 125.45 232.2 117.54 236.87 117.54 229.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.43 193.28 136.34 188.73 136.34 195.86 128.43 200.53 128.43 193.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.43 203.3 136.34 198.75 136.34 205.88 128.43 210.55 128.43 203.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.43 213.32 136.34 208.76 136.34 215.89 128.43 220.56 128.43 213.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.43 223.34 136.34 218.78 136.34 225.91 128.43 230.58 128.43 223.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.32 186.99 147.23 182.44 147.23 189.57 139.32 194.24 139.32 186.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.32 197.01 147.23 192.46 147.23 199.59 139.32 204.26 139.32 197.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.32 207.03 147.23 202.48 147.23 209.61 139.32 214.28 139.32 207.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.32 217.05 147.23 212.49 147.23 219.63 139.32 224.29 139.32 217.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.21 180.71 158.12 176.15 158.12 183.28 150.21 187.96 150.21 180.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.21 190.73 158.12 186.17 158.12 193.3 150.21 197.97 150.21 190.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.21 200.74 158.12 196.19 158.12 203.32 150.21 207.99 150.21 200.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.21 210.76 158.12 206.21 158.12 213.34 150.21 218.01 150.21 210.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.09 174.42 169.01 169.87 169.01 177 161.09 181.67 161.09 174.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.09 184.44 169.01 179.88 169.01 187.02 161.09 191.69 161.09 184.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.09 194.46 169.01 189.9 169.01 197.03 161.09 201.7 161.09 194.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.09 204.47 169.01 199.92 169.01 207.05 161.09 211.72 161.09 204.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.81,167.31l.61,1.31a.15.15,0,0,0,.2.08l1.38-.53c.22-.08.31.23.15.52l-1,1.88a.6.6,0,0,0-.07.36l.23,1.69c0,.27-.19.63-.39.6l-1.23-.15a.3.3,0,0,0-.25.14l-1.23,1.58c-.2.25-.43.16-.39-.15l.24-2a.31.31,0,0,0-.08-.27l-1-.72c-.16-.12-.07-.53.15-.69l1.38-1.07a.62.62,0,0,0,.2-.31l.62-2C168.43,167.27,168.71,167.1,168.81,167.31Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,211.36A3.46,3.46,0,0,0,136,208c-1.78-.64-3.28.78-4.39,2-.29.31.24.46.47.24,1.15-1.08,3.27-2.16,4.5-.71s.59,3.57,0,5.14c-1,2.62-3.68,5.14-6.73,4.91-6.65-.5.55-12.2,4.49-12.86.31-.06.54-.55.11-.62-2-.33-3.4,1.44-4.64,2.78a15.1,15.1,0,0,0-3.18,5.06c-1.33,3.53.63,7.87,4.94,6.49A9.35,9.35,0,0,0,138.11,211.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,207.12a8.68,8.68,0,0,0-1.18-1.38c-.16-.18-.55,0-.46.27.23.55.71.85,1,1.34a2.56,2.56,0,0,0,.16.25,8,8,0,0,0-2.79-.92,9.69,9.69,0,0,0-5.71.52c-.18.06-.11.23.05.25a2.18,2.18,0,0,0,.83-.15,11,11,0,0,1,3-.21,9.42,9.42,0,0,1,4.19,1.08,2.71,2.71,0,0,0-2.66.65c-.07.08-.08.24.06.26.63.08,1.16-.16,1.79-.14a7.08,7.08,0,0,1,2.14.38c.28.09.48-.2.47-.44A4.11,4.11,0,0,0,126.08,207.12Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pushpin--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.57,171.33l-.09.08a.8.8,0,0,1-.24.18c-.17.12-.26,0-.42-.1l-1.31-.77c-.54-.31-1.17-.68-1.84-1.09s-1.39-.84-2.09-1.29c-.21-.14.18-.83.41-.71.74.38,1.47.79,2.16,1.17s1.32.73,1.87,1l1.32.75c.15.1.31.11.3.32a.75.75,0,0,1,0,.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,172.27c-1,1.75-2.66,2.7-4.4,1.76l-.1-.05,0,0a1.88,1.88,0,0,1-.73-1.68,5.86,5.86,0,0,1,2.63-4.57,2,2,0,0,1,1.77-.23l.1.05a.83.83,0,0,1,.15.11C133.93,168.67,133.92,170.54,132.92,172.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,175.73l2-3.33a19.47,19.47,0,0,1-4.12-2.84l-.07-.08-.07-.06h0a1.15,1.15,0,0,0-1.3.05,3.81,3.81,0,0,0-1.71,3,1.2,1.2,0,0,0,.5,1.11h0a.75.75,0,0,0,.33.1A18.4,18.4,0,0,1,135,175.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.67,173a2.06,2.06,0,0,0-2.06-2.06,2,2,0,0,0-.73.14h0l-.08,0a1.54,1.54,0,0,0-.32.15,4.58,4.58,0,0,0-2.09,3.61,2.75,2.75,0,0,0,.06.52,2.06,2.06,0,0,0,4.08-.36,1.23,1.23,0,0,0,0-.19A2.06,2.06,0,0,0,138.67,173Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,172c1.15-.66,2.08-.12,2.08,1.21a4.59,4.59,0,0,1-2.08,3.6c-1.15.67-2.08.13-2.08-1.2A4.61,4.61,0,0,1,136.61,172Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Note--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.18 262.26 103.18 326.93 156.76 296 156.76 231.32 103.18 262.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.92,299.19s-31.63,17.71-35.61,19.92-6.57-4.19-6.6-8.07c-4,2.54-12.12,4.13-12.53-.94l-2.85-36.84,53.58-30.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.91 242.32 105.33 273.25 105.33 263.33 158.91 232.39 158.91 242.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.86 312.81 124.53 319.28 119.96 307.33 109.86 312.81",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,274.9a4.28,4.28,0,0,0-4.48-.35,9.57,9.57,0,0,0-5.15,5.06c-.16.43.21.81.48.42a14.58,14.58,0,0,1,2.2-2.6c0,.7.11,1.39.13,2.09,0,1.08,0,2.2,0,3.32-.07,1.86-.2,3.77-.24,5.63a1.66,1.66,0,0,1-1-.1c-.22-.13-.72.21-.54.65s.46.92,1,1a2.7,2.7,0,0,0,1.43-.18,10,10,0,0,0,2.83-1.75,14.19,14.19,0,0,0,4.34-7C123.67,278.39,123.28,276,122,274.9Zm-.08,5.35a11,11,0,0,1-3.31,6.28,8.16,8.16,0,0,1-2.49,1.65l-.12,0v-.32c0-.61,0-1.23.06-1.84.07-1.5.15-3,.17-4.47a18.42,18.42,0,0,0-.27-4.21c0-.17-.08-.38-.14-.59a7.66,7.66,0,0,1,1.1-.64,4,4,0,0,1,3.7-.12C121.72,276.68,122.25,278.2,122,280.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,302.92a16.38,16.38,0,0,0-.06-1.73c0-1.1,0-2.24,0-3.36,0-2.78,0-5.53,0-8.32,0-.61-.85-.4-.88.3a9.82,9.82,0,0,1-2,5.07c-.33.43.08.88.39.53a10.66,10.66,0,0,0,1.59-2.57c0,1.93,0,3.85,0,5.77,0,1.09,0,2.2,0,3.26a4.42,4.42,0,0,0,.17,1.68c.22.41.83-.17.86-.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64,296.33c-.1-1-.22-1.91-.27-2.9-.14-2.48-.05-5.1-.1-7.63,0-.59-.82-.44-.87.27a8.1,8.1,0,0,1-1.76,4.41c-.29.37,0,.81.26.62l.16-.12a3.69,3.69,0,0,0,.45-.5,7.06,7.06,0,0,0,.79-1.34l0-.08c0,1.71,0,3.41,0,5,.05,1,.17,2,.27,3.06,0,.45.09.91.11,1.38a3.63,3.63,0,0,0,.13,1.28c.15.28.66.14.82-.4A8.58,8.58,0,0,0,135.64,296.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,290.57c-.17.55-.21.81-.54.77a1.53,1.53,0,0,1-.89-.58c-.8-.91-.66-3.08-.83-4.61-.06-.46-.51-.37-.79,0-.69-1.35-2.37-.08-3.46,1.45a9.92,9.92,0,0,0-1.7,5.42c0,1.54.32,3,1.57,2.58s2.54-2.08,3.32-3.66a9.8,9.8,0,0,0,.53-1.34,2.77,2.77,0,0,0,.87,1.51,1.51,1.51,0,0,0,1.46.39,2.25,2.25,0,0,0,1.28-2C148.7,290,148.05,289.93,147.86,290.57Zm-3.72.15a8.1,8.1,0,0,1-2.29,3.44c-.84.67-1.18,0-1.23-1a9,9,0,0,1,.82-4.23c.71-1.47,2.26-3.1,3.08-2.35,0,0,.06,0,.09,0s0,.05,0,.08A12,12,0,0,1,144.14,290.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05,286.67c-1-.69-.66-2.8-.64-4.42,0-1.3-.21-2.89-1.17-3-1.45-.14-2.29,3.24-2.7,5.07-.15-.92-.4-1.88-1.06-2.1s-1.32.22-1.75,1.25a7.92,7.92,0,0,0-.47,2.4,18.89,18.89,0,0,1-.46-2.93c0-.25-.38-.37-.4.05a19.72,19.72,0,0,0,.08,3.46,28.46,28.46,0,0,0,.6,3.08c.1.39.78.25.89-.37.34-1.88-.12-3.84.7-5.73,0-.05,0-.07.08-.07a.45.45,0,0,1,.31.09,2.42,2.42,0,0,1,.49,1.25,18.08,18.08,0,0,1,.19,3.59c0,.65.81.28,1-.38.45-2,.7-3.91,1.35-5.9a7.15,7.15,0,0,1,.52-1.28,2.53,2.53,0,0,1,.13-.22c-.06.1.12-.13,0,0l0,0h0s0,0,0,0a1.44,1.44,0,0,1,.53.89,9.14,9.14,0,0,1,.07,2.18c-.07,1.79-.1,3.61,1,4.21C156.8,288,157.51,287,157.05,286.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.94,272a.57.57,0,0,0-.35.08l-.11-.05a3.15,3.15,0,0,0-.43-.05,2.94,2.94,0,0,0-.66.05,3.4,3.4,0,0,0-1.25.58,5.82,5.82,0,0,0-1.71,2.25c-.76,1.63-1.23,3.85-.42,5.55a3.24,3.24,0,0,0,4.66,1,7.15,7.15,0,0,0,2.67-4.75C133.64,274.85,133.27,272.11,130.94,272Zm1.07,4.22a6.55,6.55,0,0,1-2,4.09,2.63,2.63,0,0,1-.87.46,1.75,1.75,0,0,1-.84.05l-.27-.07a.28.28,0,0,1-.13-.05l-.17-.07-.12-.1-.1-.1-.09-.11a2.86,2.86,0,0,1-.21-.43,5.32,5.32,0,0,1-.19-1,8.14,8.14,0,0,1,0-1.2,7.68,7.68,0,0,1,.77-2.52,4.26,4.26,0,0,1,1.62-1.88,2.34,2.34,0,0,1,1.22-.26l.48.06a1,1,0,0,1,.23.11l.16.12a.52.52,0,0,1,.1.11l.08.11a.51.51,0,0,1,.09.16,1.26,1.26,0,0,1,.15.36A5,5,0,0,1,132,276.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,272.39a1,1,0,0,0-.43.27,5.06,5.06,0,0,0-.69,1.3,3.56,3.56,0,0,1-.5.74,4.42,4.42,0,0,1-1.48,1.18,2.5,2.5,0,0,1-.78.28l-.21,0h-.42l-.2,0-.08,0-.18-.08-.06,0,0,0-.17-.13-.06-.06-.16-.18-.12-.18a3.2,3.2,0,0,1-.38-.94,3.48,3.48,0,0,1-.05-.36v-.36a10,10,0,0,1,1.26-4.26,4.6,4.6,0,0,1,1.33-1.66,1.26,1.26,0,0,1,1.75.2.27.27,0,0,0,.42,0,.46.46,0,0,0-.09-.52,2.16,2.16,0,0,0-2.27-.89,3.66,3.66,0,0,0-1.84,1.5,10.64,10.64,0,0,0-1.87,5,3.81,3.81,0,0,0,2.1,4,4.23,4.23,0,0,0,4.33-1.25,5,5,0,0,0,1.36-2.27c.09-.34.27-1.19-.28-1.25A.66.66,0,0,0,142.45,272.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,272.52a1.16,1.16,0,0,0-.1-.28c0-.06-.07-.12-.11-.17a.77.77,0,0,0-.15-.16.85.85,0,0,0-.25-.17.91.91,0,0,0-.85,0,.94.94,0,0,0-.28.21,1.43,1.43,0,0,0-.14.2v0a.42.42,0,0,0,0,.36l.07.12,0,.06c0,.06,0,.11,0,.17a.9.9,0,0,0,.29.59,1,1,0,0,0,.5.22.93.93,0,0,0,.41-.05,1.46,1.46,0,0,0,.3-.17.83.83,0,0,0,.2-.22.93.93,0,0,0,.13-.56A.88.88,0,0,0,148,272.52Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Marker--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--marker--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.18,301.79a22.25,22.25,0,0,0-10.08-17.46c-2.75-1.59-5.24-1.75-7.06-.74h0l-.06,0h0L166,357.81l14.32,24.65,128.87-74.15h0C311.06,307.25,312.18,305,312.18,301.79Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,301.79a22.25,22.25,0,0,0-10.08-17.46c-2.75-1.59-5.24-1.75-7.06-.74h0l-.06,0h0L166,357.81l14.32,24.65,128.87-74.15h0C311.06,307.25,312.18,305,312.18,301.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23,291.85a20.45,20.45,0,0,0-7.13-7.52c-2.75-1.59-5.24-1.75-7.06-.74h0l-.06,0h0L166,357.81l7.16,12.33,136-78.27Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23,291.85a20.45,20.45,0,0,0-7.13-7.52c-2.75-1.59-5.24-1.75-7.06-.74h0l-.06,0h0L166,357.81l7.16,12.33,136-78.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46,365.42l135.52-78a17.16,17.16,0,0,0-3.88-3.13c-.28-.17-.56-.31-.83-.44L167.72,360.71Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,358.5A22.29,22.29,0,0,1,183.28,376c0,6.43-4.52,9-10.09,5.82a22.32,22.32,0,0,1-10.08-17.46C163.11,357.89,167.63,355.29,173.19,358.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.19,313c1.82-1.06,2.94-3.31,2.94-6.52A22.25,22.25,0,0,0,294.05,289c-2.75-1.59-5.24-1.76-7.06-.74l2.87-1.67c1.81-1,4.31-.85,7.06.74A22.32,22.32,0,0,1,307,304.77c0,3.21-1.13,5.47-2.95,6.52Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,382.46l128.87-74.15h0c1.82-1.06,2.94-3.31,2.94-6.52a16.17,16.17,0,0,0-.41-3.54l-135,78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,376.43c0-6.95-4.88-15.4-10.91-18.88-3-1.74-5.73-1.9-7.7-.76l-44.26,25.55L136.78,409l44.12-25.47C182.87,382.36,184.1,379.91,184.1,376.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67,361.27l-44.18,25.5a18.71,18.71,0,0,0-4.49-3.7l44.19-25.52A18.72,18.72,0,0,1,177.67,361.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,376.43c0,3.49-1.22,5.93-3.21,7.07L136.79,409h0c1.94-1.14,3.13-3.57,3.13-7a20.8,20.8,0,0,0-2-8.31l44.19-25.52A20.81,20.81,0,0,1,184.1,376.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,383.07c6,3.47,10.91,11.93,10.91,18.88S135,411.72,129,408.24s-10.9-11.93-10.9-18.88S123,379.59,129,383.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,408.24c6,3.48,10.91.66,10.91-6.29a22.23,22.23,0,0,0-3.2-10.75c2,4.46,3.2,11.84.59,15.26S131.38,408.84,129,408.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,387.53c-3.87-2.22-7-.41-7,4.07a15.56,15.56,0,0,0,7,12.17c3.88,2.24,7,.42,7-4.06A15.57,15.57,0,0,0,129,387.53Zm0,13.8a10.87,10.87,0,0,1-4.92-8.52c0-3.13,2.21-4.4,4.92-2.83a10.85,10.85,0,0,1,4.93,8.52C133.93,401.64,131.73,402.9,129,401.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.08 390.93 145.36 392.51 148.08 394.08 150.81 392.51 148.08 390.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,375.06l-2.73-1.57a2.43,2.43,0,0,0-2.45.22h0l-35.25,20.36v9.44l35.25-20.35a7.7,7.7,0,0,0,3.49-6v-.35l.32.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,377.31v1.4a7.73,7.73,0,0,1-3.49,6L150.81,405.1v-9.45l35.25-20.35h0C188,374.2,189.55,375.1,189.55,377.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.36 401.95 145.36 392.51 150.8 395.66 150.81 405.1 145.36 401.95",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.2,109.52l-3.61-6.79,2.9-8.38V89.23l-8.88,5.12v5.13l3.82,6.62a.53.53,0,0,0,.26.23h0Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2,109.52l-3.61-6.79,2.9-8.38V89.23l-8.88,5.12v5.13l3.82,6.62a.53.53,0,0,0,.26.23h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.41,48.46a5.85,5.85,0,0,0-2.67-4.61l-2.16-1.26a5.89,5.89,0,0,0-5.33,0L367,61.83a5.89,5.89,0,0,0-2.67,4.61V103a5.89,5.89,0,0,0,2.67,4.61l2.16,1.25a5.89,5.89,0,0,0,5.33,0l10.7-6.18,3.81,6.6a.57.57,0,0,0,1-.09l4-11.63,13.69-7.93a5.86,5.86,0,0,0,2.67-4.61Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.33,103a5.89,5.89,0,0,0,2.67,4.61l2.16,1.25a6,6,0,0,0,4.88.22c-1.26.47-2.21-.24-2.21-1.76V70.77a5.5,5.5,0,0,1,.78-2.63l-7.5-4.32a5.43,5.43,0,0,0-.78,2.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.32,47.7c-.31-1.13-1.34-1.49-2.57-.78L374.49,66.16a5.36,5.36,0,0,0-1.88,2l-7.49-4.32a5.47,5.47,0,0,1,1.88-2L400.24,42.6a5.89,5.89,0,0,1,5.33,0l2.18,1.25A5.89,5.89,0,0,1,410.32,47.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-35",
    d: "M402.2,57.15a3.07,3.07,0,0,0-4,1.63L386.64,86.27l-2.75-2.67A3.05,3.05,0,0,0,379.63,88l6,5.8a3,3,0,0,0,2.13.86,3.08,3.08,0,0,0,.61-.06,3,3,0,0,0,2.21-1.81l13.29-31.62A3.06,3.06,0,0,0,402.2,57.15Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "270.42 213.96 273.87 217.02 272.51 223.72 261.72 227.34 254.14 223.63 250.69 220.58 270.42 213.96",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.42 213.96 273.87 217.02 272.51 223.72 261.72 227.34 254.14 223.63 250.69 220.58 270.42 213.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.06 220.67 258.26 224.29 250.69 220.58 270.42 213.96 269.06 220.67",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.26 224.29 261.72 227.34 254.14 223.63 250.69 220.58 258.26 224.29",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,223.12c-4.59,1.54-9.12.34-14.51-.57s-10,.66-17.19,3.08h0a3.25,3.25,0,0,1-3.15-1,10.22,10.22,0,0,1-2.95-8.79,3.27,3.27,0,0,1,1.93-2.67h0c7.24-2.43,11.9-4,15.58-7.9s6.64-7.66,11.23-9.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,223.12l1.1-.37,116-38.89,10.05-3.37-1.05-3.18-.86-2.59-1.72-5.16-.86-2.6-1.71-5.16L423,156.62,422,153.44l-3.25,1.08L295.61,195.77a.14.14,0,0,0-.09,0l-.59.2a.11.11,0,0,0-.08,0c-1.62.69-2.92,2.31-3.59,4.75a9,9,0,0,0-.24.93,17.37,17.37,0,0,0-.21,5A23.11,23.11,0,0,0,292,212a20.68,20.68,0,0,0,5.49,8.82C299.64,222.79,301.85,223.5,303.74,223.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.81,206.68A23.11,23.11,0,0,0,292,212L426.44,167l-1.71-5.16L423,156.62,422,153.44l-3.25,1.08L295.61,195.77a.14.14,0,0,0-.09,0l-.59.2a.11.11,0,0,0-.08,0c-1.62.69-2.92,2.31-3.59,4.75a9,9,0,0,0-.24.93A17.37,17.37,0,0,0,290.81,206.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,156.62,291.26,200.78a9,9,0,0,0-.24.93,17.37,17.37,0,0,0-.21,5l133.91-44.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72,159.26a22.28,22.28,0,0,0,6.41,19.11c4.82,4.26,9.76,2.6,11-3.7a22.31,22.31,0,0,0-6.41-19.11C423.94,151.3,419,153,417.72,159.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.94,179.3c-5.21-4.6-8.31-13.86-6.93-20.67.69-3.41,2.38-5.56,4.54-6.28L470,136.11l9.65,29.28-48.3,16.19C429.19,182.31,426.55,181.61,423.94,179.3Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.83,164.44l48.37-16.22a18.39,18.39,0,0,1,.2-5.81L417,158.62A19.07,19.07,0,0,0,416.83,164.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.94,179.3c2.61,2.31,5.25,3,7.42,2.28l48.29-16.18v0c-2.14.69-4.75,0-7.32-2.3a20.9,20.9,0,0,1-4.94-7L419,172.33A20.68,20.68,0,0,0,423.94,179.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.39,142.41c-1.38,6.82,1.72,16.07,6.93,20.68s10.56,2.81,11.94-4-1.72-16.07-6.93-20.68S466.78,135.6,465.39,142.41Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.39,142.41c-1.38,6.82,1.72,16.07,6.93,20.68s10.56,2.81,11.94-4-1.72-16.07-6.93-20.68S466.78,135.6,465.39,142.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.72,141.31c-1.42.46-2.52,1.85-3,4.07a15.55,15.55,0,0,0,4.47,13.32c1.65,1.46,3.33,1.93,4.72,1.49s2.53-1.84,3-4.06a15.57,15.57,0,0,0-4.46-13.34C474.79,141.33,473.1,140.87,471.72,141.31Zm.93,2.84a3.46,3.46,0,0,1,3.3,1,10.9,10.9,0,0,1,3.13,9.34,3,3,0,0,1-5.39,1.81,10.91,10.91,0,0,1-3.12-9.33A3.45,3.45,0,0,1,472.65,144.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.65 161.92 461.64 160.92 461.01 164 458.03 165 458.65 161.92",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,181.72l.63-3.09a2.45,2.45,0,0,1,1.79-1.69h0L461,164l7.08,6.26L429.5,183.19a7.73,7.73,0,0,1-6.84-1.38l-.26-.24-.06.37Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,184l1.05.92a7.69,7.69,0,0,0,6.83,1.39l38.59-12.94-7.07-6.25L421.79,180h0C419.68,180.75,419.33,182.5,421,184Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,184l1.05.92a7.69,7.69,0,0,0,6.83,1.39l38.59-12.94-7.07-6.25L421.79,180h0C419.68,180.75,419.33,182.5,421,184Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.71 167.17 461.64 160.92 460.39 167.09 467.46 173.34 468.71 167.17",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.71 167.17 461.64 160.92 460.39 167.09 467.46 173.34 468.71 167.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,183.47c9.34-1,13,1.64,13.29,10,.3,8-4.65,20.54-4.65,20.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,396.63c-.62-.05-.53,1.8-.3,2.59s2.79,3.42,7.31,4.31,10.75,0,13.42-.16,7.3,1.11,10,1.47,7.47-.6,9-2.12a2.81,2.81,0,0,0,.63-2.21c-.07-1.78-.24-2.13-.44-2.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.92,393.12c.08.35.16.7.23,1.05a17.56,17.56,0,0,1,.38,5.45,5,5,0,0,1-3.22,2.44c-3.16,1-5.57.84-9.07.18a26.5,26.5,0,0,0-6.9-.65c-2.76.18-6.55.71-9.31.46a22.17,22.17,0,0,1-6.85-1.4A8.58,8.58,0,0,1,341,397a6.26,6.26,0,0,1,3.46-6.23,14.06,14.06,0,0,1,6.93-1.49c2.61,0,4.58.34,6.89.16a11.17,11.17,0,0,0,4.59-1.13,4.47,4.47,0,0,0,1.44-2.06c.37-.82.5-1.56,1.24-1.64,0,0,10.92-.27,12-.17,1.28.1,1.51,4.51,1.67,5.37.12.67.14,1.4.32,2.05C379.7,392.25,379.82,392.68,379.92,393.12Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.92,393.12c.08.35.16.7.23,1.05a17.56,17.56,0,0,1,.38,5.45,5,5,0,0,1-3.22,2.44c-3.16,1-5.57.84-9.07.18a26.5,26.5,0,0,0-6.9-.65c-2.76.18-6.55.71-9.31.46a22.17,22.17,0,0,1-6.85-1.4A8.58,8.58,0,0,1,341,397a6.26,6.26,0,0,1,3.46-6.23,14.06,14.06,0,0,1,6.93-1.49c2.61,0,4.58.34,6.89.16a11.17,11.17,0,0,0,4.59-1.13,4.47,4.47,0,0,0,1.44-2.06c.37-.82.5-1.56,1.24-1.64,0,0,10.92-.27,12-.17,1.28.1,1.51,4.51,1.67,5.37.12.67.14,1.4.32,2.05C379.7,392.25,379.82,392.68,379.92,393.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,388.61a8,8,0,0,0-2.73,5.29c.07,1.33-2.28,1.45-2.35.11a11.38,11.38,0,0,1,2.07-4.69A4.28,4.28,0,0,1,362.16,388.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.05,389.45a8.28,8.28,0,0,0-2.52,4.52c0,1-2.08.9-2-.09,0,0,.28-3.15,2.53-4.49C355.65,388.94,356.83,389.06,357.05,389.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,389.28c-1.07,0-3.33,1.48-4.41,4.8a19,19,0,0,0-.42,7.47,10.64,10.64,0,0,1-6-2.78,6.52,6.52,0,0,1-1.51-1.87,6.59,6.59,0,0,1,1.08-5.06c1.55-1.89,3.95-3.13,7.77-3.37,4.27-.26,4.65.87,4.65.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.41,253.17c-.41-7-4.64-12.94-8.71-21.95,0,0-36.57-15.09-38.9,1.55-3.07,21.93,0,76.14.6,81.6.8,7.68.83,16.17,1.51,29.82.76,15.15,1.87,40.86,1.87,40.86h0l.11.92c0,.86,2.57,2.52,5.84,2.48,4.66-.07,6.09-1.28,6-2.18,0-.1,0-.22,0-.36h0s6.53-37.86,6.48-46.75c-.08-11.68-2.24-18.69-2.24-18.69l3.36-41.87",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.94,358.12c-.06,2.1-.23,4,.7,6.26,1.33,3.24,3.87,4.63,5.39,5.86a25,25,0,0,1,4.47,4.91,21.67,21.67,0,0,0,4.68,5.28c1.44,1.12,5.31,1,7.14.16s2.42-1.62,2.15-4.59-9.35-3.54-9.35-3.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,367.16c.78.26,1.05,1.72,1.32,4.63.2,2.21,1.29,5.4-1.69,6.94-2.4,1.25-6.36.7-8.12-1.3-2.2-2.5-3.72-4.72-6.83-7.74-2.7-2.62-5.42-3.42-6.83-8.86-.91-3.5-.41-5,1.92-6.13,3.2-1.56,8.57,2.74,11.17,3.33C405,358.54,411.07,366.91,411.86,367.16Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,367.16c.78.26,1.05,1.72,1.32,4.63.2,2.21,1.29,5.4-1.69,6.94-2.4,1.25-6.36.7-8.12-1.3-2.2-2.5-3.72-4.72-6.83-7.74-2.7-2.62-5.42-3.42-6.83-8.86-.91-3.5-.41-5,1.92-6.13,3.2-1.56,8.57,2.74,11.17,3.33C405,358.54,411.07,366.91,411.86,367.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,358c-.14,0-.29-.08-.45-.13a8.47,8.47,0,0,0-6.85,5c-.38,1,1,1.67,1.76.88a9,9,0,0,1,6.85-5A3.79,3.79,0,0,0,402.8,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,359.59a8.36,8.36,0,0,0-6.35,4.94c-.39,1,1,1.66,1.75.87a8.65,8.65,0,0,1,5.69-4.7C405.71,360.3,405.35,359.93,405,359.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,364.82s-.07-6.56,8.73-7.91l.53.26a7.67,7.67,0,0,0-4.53-3.14c-3-.65-5.26.23-6.71,2.3S389.82,363.62,391.41,364.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,273.25s1.22,17.92,3,30.15c1.25,8.55,2.63,12.12,5.25,26.35,2.28,12.35,7.31,37.49,7.31,37.49,1.23,2.75,8.21,2.72,10.08,1.12l.08-4.08s3.36-32.11,1.56-42.82-4.62-15.6-4.62-15.6.05-15.26-.06-29.48c-.09-10.84,0-16.82-.41-23.85",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,288.24s-.69,2.21-9.55,3.17a36.53,36.53,0,0,1-14.71-1.22l-.83-7.27-.52,9.83s-5.64,2.52-15.22,1.9c-1.57-.1-2.94-.23-4.15-.39-.84-.11-2.31-11.64-2.5-15.4-.68,5-1.22,14.74-1.8,14.59a14,14,0,0,1-4.71-2s.81-21.59,1.65-31.93c1.11-13.64,3-26.76,3-26.76l38.9-1.54c1.24,2.33,2.92,5.1,4.37,7.62.24.41.47.83.69,1.27.15.27.29.55.43.83a39.67,39.67,0,0,1,3.64,10.2,48.88,48.88,0,0,1,.55,5.12c0,.5.07,1,.1,1.53C411.06,268,411.17,288.24,411.17,288.24Z",
    style: {
      fill: "#692ED6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,268.45a15.3,15.3,0,0,0,8.77-10.06c-5.16,6.52-10.92,7.75-10.92,7.75l-1.44,16.78.83,7.27a21.71,21.71,0,0,0,2.41.63C389.53,283,389.67,268.45,389.67,268.45Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,173.08l.09,10h0c2.17.88,1.52,4,.05,5.81l0,2.94-14.73-.9L375.57,174Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.39,190.59c-1.22-4.4-5.54-6.79-9.62-7.25-1.45-.16-3.72-.28-3.72-.28-1.53,2.49-12.36,1.87-15,.57l-9.17.35c-.59.54-3.36,4.68-9.63,17.7-2.69,5.56-.86,12.75,4.34,15.16.15,3.59.22,15.93.22,15.93,7.27,4.79,33.09,6.28,38.9-1.55.11-5.82,1.46-9.11,3-14.84C406.49,206.15,405.85,195.83,404.39,190.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,151.82s-9.84-6.24-.73-15.39c6.55-6.57,16.2-4.91,27.55.11,5.31,2.36,12.81,8.55,12.64,19.34-.14,8.32-23.73,12.55-23.66,18.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,156s-3.54,4.77-3.14,5.32A7.8,7.8,0,0,0,365,162.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.52,140.83c-3.27,1.47-8.94,4.21-11,15.85-2.11,11.95.34,16.28,1.9,17.95,1.05,1.12,6.74,1.82,9.77,1.06,3.79-1,12.09-4.51,16.21-10.51,4.86-7.07,6.31-16.76,1.37-20.85C387.84,138.56,379.29,139.58,376.52,140.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.66,175.93A18,18,0,0,1,368,175a14.18,14.18,0,0,0,7.72-1.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.52,155a12,12,0,0,1-6.86-10.25c-.56-7.74,9.25-10.2,9.25-10.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,154.28a16.15,16.15,0,0,0-.45-4.15,17.35,17.35,0,0,0-10.12-11.49c-12.88-5.08-21.7,2.64-21.7,2.64a40.52,40.52,0,0,0-1.61,12,2.74,2.74,0,0,0-.85-.11l-.43,5.25a2.9,2.9,0,0,0,2.65,3.12l.25-3c.8-1.12,2.68-3.13,5.36-2.08a4.6,4.6,0,0,1,2.45,5.82,6.63,6.63,0,0,1-2.05,3.12c-1.45,1.25-2.66.74-4.44.44a.69.69,0,0,0-.49,0c-.23.15-.2.49-.14.76a29.34,29.34,0,0,0,1.66,5.55,9.72,9.72,0,0,0,3.63,4.42,14.65,14.65,0,0,0,6,1.62,5.37,5.37,0,0,0,6.09-2.14l7.15-8a31.57,31.57,0,0,0,5.66-7.78A16,16,0,0,0,407.82,154.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.79,
    cy: 129.93,
    r: 9.32,
    transform: "translate(-18.73 169.87) rotate(-23.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,138.68a6,6,0,1,1-5.77-6.15A6,6,0,0,1,411,138.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.44,129.73a6,6,0,1,1-5.77-6.15A6,6,0,0,1,395.44,129.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.48,257.8a3.63,3.63,0,0,1-2.35,1.72h-.05c-1.88.1-5.41-2.92-7.35-4.74a2.56,2.56,0,0,1-.79-1.42l-2.17-11.19a.49.49,0,0,1,.1-.37.39.39,0,0,1,.34-.18,22.2,22.2,0,0,0,7.55-1.5c.15.27.29.55.43.83a22.9,22.9,0,0,1-7.41,1.57l2.06,10.67a1.77,1.77,0,0,0,.52.92c3,2.83,5.58,4.55,6.68,4.49h0c.75-.06,1.59-1.07,2.33-2.33C410.42,256.77,410.45,257.28,410.48,257.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.86,243.37a55.71,55.71,0,0,1-14.89.75.48.48,0,0,0-.35.1.49.49,0,0,0-.16.32l-.85,10.67A4.85,4.85,0,0,0,371,259c2.25,2.33,5.32,5.05,7.33,4.94h.13c2-.23,5-3.39,7.23-6a4.8,4.8,0,0,0,1.12-3.24l-.36-10.84a.47.47,0,0,0-.54-.44Zm0,11.31a3.84,3.84,0,0,1-.9,2.62c-2.88,3.45-5.3,5.51-6.62,5.67s-3.7-1.56-6.69-4.66a3.91,3.91,0,0,1-1.09-3l.81-10.21a56.28,56.28,0,0,0,14.15-.71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,183.91c-12.75-.47-13.4,2.11-20.39,13.17-3.77,6-9.84,15.94-13.4,21.92-5.75-2.13-15.49-6-19.1-9-.89-.75-2.19-1.67-2.35-2.83-.42-3.18-2.17-4-3.29-6.75-.86-2.11-.69-3.5-1.25-3.52-.73,0-2,.49-2.2,2.49a16.11,16.11,0,0,0,.44,3.93,5.69,5.69,0,0,1-2.13-2.25,12.92,12.92,0,0,1-1.37-5A8.8,8.8,0,0,1,304,193l1.11-.37c-.45-.63-2-.59-2.72-.49a3.22,3.22,0,0,0-2.12,1.16c-.41.53-.65,1.19-1.1,1.69-.67.76-1.78,1.14-2.19,2.07a20.87,20.87,0,0,0-.36,2.26,10.84,10.84,0,0,1-1,1.71,4.7,4.7,0,0,0-.35,3.18,10.27,10.27,0,0,0,.69,2.07,7.22,7.22,0,0,0,.45,1c.17.27.4.53.59.79a27.24,27.24,0,0,0,3.18,3.44c.61.59,1.24,1.16,1.87,1.74,2.33,2.16,6.59,5.32,9.85,7.68,8.34,6,22.81,13.38,25.41,14,3.19.73,4.64-1.36,7-4.26,4.52-5.44,15.3-22.24,15.3-22.24C368.67,204.28,370,190.35,368.93,183.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.f46fe6df711979853069f38c066644bc.svg";
export { ForwardRef as ReactComponent };